import * as React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchMoreSchemasAsync,
  selectSchemas,
  selectSchemasLoading,
  selectSchemasLoadingMore,
  selectSchemasError,
  selectSchemasHasMore,
} from '../../../redux/flows/schemasSlice';
import SchemaCard from './SchemaCard';
import SchemaFilters from './SchemaFilters';
import useSchemaFilters from './useSchemaFilters';
import { schemaPanelStyles as styles } from '../styles/schemaPanelStyles';

const SCROLL_THRESHOLD_PX = 80;

export default function SchemaPanel() {
  const dispatch = useDispatch();
  const { form, handleClear } = useSchemaFilters();

  const schemas = useSelector(selectSchemas);
  const loading = useSelector(selectSchemasLoading);
  const loadingMore = useSelector(selectSchemasLoadingMore);
  const error = useSelector(selectSchemasError);
  const hasMore = useSelector(selectSchemasHasMore);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (
      hasMore &&
      !loadingMore &&
      !loading &&
      scrollHeight - scrollTop - clientHeight < SCROLL_THRESHOLD_PX
    ) {
      dispatch(fetchMoreSchemasAsync());
    }
  };

  return (
    <Box sx={styles.panel}>
      <Box sx={styles.header}>
        <SchemaFilters form={form} onClear={handleClear} />
      </Box>

      <Box sx={styles.list} onScroll={handleScroll}>
        {error && (
          <Typography variant="caption" sx={styles.errorMessage}>
            Could not load schemas: {error}
          </Typography>
        )}

        {loading && (
          <Box sx={styles.centered}>
            <CircularProgress size={24} sx={styles.spinner} />
          </Box>
        )}

        {!loading && !error && schemas.length === 0 && (
          <Typography variant="caption" sx={styles.message}>
            No schemas found.
          </Typography>
        )}

        {!loading && schemas.map((schema) => <SchemaCard key={schema.id} schema={schema} />)}

        {loadingMore && (
          <Box sx={styles.centered}>
            <CircularProgress size={18} sx={styles.spinner} />
          </Box>
        )}
      </Box>
    </Box>
  );
}
